import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69fc4a24f6558f00141013ea/unoc/src/app/projects/page.tsx");
